import { requestApi } from '../util/network'

// 新增发票
export const getDadaShop =
    (data) =>
      requestApi(
        '/seller_dada_shop/detail',
        'POST',
        {

        },
        'seller'
      )
// 新增发票
export const saveDadaShop =
    (data) =>
      requestApi(
        '/seller_dada_shop/save',
        'POST',
        data,
        'seller'
      )
